import { render } from "./SocialsBody.vue?vue&type=template&id=098df6a8"
import script from "./SocialsBody.vue?vue&type=script&lang=js"
export * from "./SocialsBody.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__